import React, { useEffect, useState } from "react";
import DefaultImg from "../images/no_profile.png";
import { getCountryCallingCode } from "react-phone-number-input";

import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import Button from "@mui/joy/Button";

const { REACT_APP_IMAGE_URL } = process.env;

const UserDetails = ({ show, handleClose, user }) => {
  const [details, setDetails] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
  });

  const handleChange =(e,key)=>{
    const value = e.target.value ;
    setDetails((prev)=>({
        ...prev,[key]:value
    }))
    console.log("changed ")
  }

  useEffect(() => {
    if (user?.shipping_addresses) {
      const res = user?.shipping_addresses?.[0];
      setDetails({
        first_name: res?.first_name,
        last_name: res?.last_name,
        phone_number: res?.phoneNumber,
      });
    }
    setDetails((prev)=>({...prev,email: user?.email,}))
  }, [user]);

  return (
    <Modal open={show} onClose={handleClose}>
      <ModalDialog
        sx={{
          borderRadius: "16px",
          width: 500,
          maxWidth: "90%",
          p: 3,
          overflow: "hidden",
        }}
      >
        <DialogTitle sx={{ textDecoration: "underline" }}>
          Edit User Details
        </DialogTitle>

        <DialogContent sx={{ px: 0 }}>
          {/* <div style={{ textAlign: "center", marginBottom: 10 }}>
            <img
              src={
                user?.profile_pic
                  ? `${REACT_APP_IMAGE_URL}${user?.profile_pic}`
                  : DefaultImg
              }
              style={{
                width: 50,
                height: 50,
                borderRadius: "50%",
                border: "2px solid #eee",
                objectFit: "cover",
              }}
              alt="profile"
            />
          </div> */}

          <div style={{ display: "grid", gap: "12px" }}>
            <div className="">
              <p className="mb-1">
                <strong>First Name</strong>
              </p>
              {/* <span>{user?.user_name ?? "N/A"}</span> */}
              <input className="form-control" value={details?.first_name} onChange={(e)=>handleChange(e,"first_name")}/>
            </div>
            <div className="">
              <p className="mb-1">
                <strong>Last Name</strong>
              </p>
              {/* <span>{user?.user_name ?? "N/A"}</span> */}
              <input className="form-control" value={details?.last_name} onChange={(e)=>handleChange(e,"last_name")}/>
            </div>
            <div>
              <p className="mb-1">
                {" "}
                <strong>Email</strong>
              </p>
              {/* <span>{user?.email ?? "N/A"}</span> */}
              <input className="form-control" value={details?.email} onChange={(e)=>handleChange(e,"email")}/>
            </div>

            <div>
              <p className="mb-1">
                {" "}
                <strong>Phone</strong>
              </p>
              {/* <span>
        {user?.phone_no
          ? `${user?.country_code ? `+${getCountryCallingCode(user?.country_code)} ` : ""}${user?.phone_no}`
          : "N/A"}
      </span> */}
              <input className="form-control" value={details?.phone_number} onChange={(e)=>handleChange(e,"phone_number")}/>
            </div>

            {/* <div>
              <p className="mb-1">
                {" "}
                <strong>Location:</strong>
              </p>

              <input className="form-control" />
            </div> */}
            {/* <span>{user?.country_code ?? "N/A"}</span> */}

            {/* <div>
              <p className="mb-1">
                <strong>Created:</strong>
              </p>

              <input className="form-control" />
            </div> */}
            {/* <span>{new Date(user?.created_at).toLocaleString()}</span> */}
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
           Submit
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};

export default UserDetails;
